import React from 'react'
import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { explorePageInitialProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import StudentLoanRefinancePage from 'experiences/explore/simpleExplorePages/StudentLoanRefinancePage'
import { ExplorePageProps } from 'types/page'
import { ContentfulProducts } from 'parameters/products'
import { ROUTES } from 'parameters'
import { ProductConstraint } from 'services/ContentfulService/constraints'
import { DashboardLayout } from 'components/layout/LoggedIn/DashboardLayout'

const NativeStudentLoanRefinance: NextPage<PagePropsWrapper<ExplorePageProps>> = ({
	metaTags,
	pageProps: { articles }
}): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<DashboardLayout>
			<StudentLoanRefinancePage articles={articles} />
		</DashboardLayout>
	</StandardLayout>
)

NativeStudentLoanRefinance.getInitialProps = explorePageInitialProps(
	ROUTES.STUDENT_LOAN_REFINANCE,
	ProductConstraint(ContentfulProducts.SLR)
)

export default NativeStudentLoanRefinance
